<template>
  <div v-if="dataOrigin.state === 'inactive'" class="inactive"></div>
</template>

<script>
export default {
  props: {
    dataOrigin: {
      type: Object,
      required: true
    }
  }
};
</script>

<style scoped>
.inactive {
  width: 100%;
  height: 100%;
  background: #333;
}
</style>
